import gql from 'graphql-tag';

export const mutationDeleteWebpage = gql`
  mutation deleteWebpage (
    $id: DokkioID!
  ) {
    deleteWebpage (
      id: $id
    )
  }
`;
export default mutationDeleteWebpage;
